import { useAlert } from '@spritz-finance/ui'
import { useState } from 'react'
import styled from 'styled-components'

import CopyIconImage from '../assets/icons/copy.svg'

export const CopyIcon = styled.img.attrs({
    src: CopyIconImage,
})`
    width: 16px;
    height: 16px;
    cursor: pointer;
`

export const useCopyToClipboard = () => {
    const alert = useAlert()
    const [copiedText, setCopiedText] = useState<string | null>(null)

    const copy = async (text: string) => {
        if (!navigator?.clipboard) {
            console.warn('Clipboard not supported')
            return false
        }

        try {
            await navigator.clipboard.writeText(text)
            setCopiedText(text)
            alert.success('Copied to clipboard!')
            return true
        } catch (error) {
            console.warn('Copy failed', error)
            setCopiedText(null)
            return false
        }
    }

    return { copiedText, copy }
}
